import React from 'react';
import { BucketDisplayData } from '../../types';
import { Button } from '@privemind/components';
import { formatCurrency } from '@privemind/utils/formatting';
import './bucket-summary-card.scss';

interface BucketSummaryCardProps {
  bucket: BucketDisplayData;
  onViewBucket: (bucketName: string) => void;
  onDeleteBucket: (bucketName: string) => void;
}

export const BucketSummaryCard: React.FC<BucketSummaryCardProps> = ({
  bucket,
  onViewBucket,
  onDeleteBucket,
}) => {
  const handleDelete = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (window.confirm(`Delete bucket "${bucket.name}" and all its assets?`)) {
      onDeleteBucket(bucket.name);
    }
  };


  return (
    <div 
      className="bucket-summary-card"
      onClick={() => onViewBucket(bucket.name)}
    >
      <div className="bucket-summary-card__header">
        <h3 className="bucket-summary-card__name">{bucket.name}</h3>
        <Button
          color="danger"
          size="sm"
          onClick={() => handleDelete({} as React.MouseEvent)}
          className="bucket-summary-card__delete"
        >
          Delete
        </Button>
      </div>
      
      <div className="bucket-summary-card__content">
        <div className="bucket-summary-card__stats">
          <div className="bucket-summary-card__stat">
            <span className="bucket-summary-card__stat-label">Total Value</span>
            <span className="bucket-summary-card__stat-value">
              {formatCurrency(bucket.value)}
            </span>
          </div>
          
          <div className="bucket-summary-card__stat">
            <span className="bucket-summary-card__stat-label">Assets</span>
            <span className="bucket-summary-card__stat-value">
              {bucket.assets.length}
            </span>
          </div>
          
          <div className="bucket-summary-card__stat">
            <span className="bucket-summary-card__stat-label">Allocation</span>
            <span className="bucket-summary-card__stat-value">
              {bucket.allocation.toFixed(1)}%
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};
